import Cookie from 'js-cookie'

export const useCookies = () => {
  const setCookie = (id: string, value: string, expire: number = 7) => {
    Cookie.set(id, value, { expires: expire })
  }

  const getCookie = (id: string) => Cookie.get(id)

  return {
    setCookie,
    getCookie
  }
}